<div [formGroup]="formGroup">
	<div class="date-picker-row">
		<div class="date-column">
			<input #datePickerInput [id]="id" type="text" dateInput [owlDateTimeTrigger]="dt" [owlDateTime]="dt" [disabled]="disabled" [owlDateTimeFilter]="filterDates" [placeholder]="placeholder" formControlName="datePicker" (dateTimeChange)="onSelectedDateChanged($event)" (blur)="onBlur($event)" />
		</div>
		
		@if (clearable) {
			<div class="padding-left-small">
				<button type="button" class="button minimal-padding no-margin" (click)="clearDate()" [disabled]="disabled" aria-label="Reset Date">Reset</button>
			</div>
		}
	</div>
	<owl-date-time #dt [pickerType]="'calendar'"></owl-date-time>
</div>



